import { Navigate, useParams } from "react-router-dom"

// /safety/:slug was this page's URL before it was renamed to /analysis/:slug.
// Registered at the old path so bookmarks, shared links and already-indexed
// search results keep working instead of 404ing.
export default function RedirectToAnalysis() {
    const { slug } = useParams()
    return <Navigate to={`/analysis/${slug}`} replace />
}
